import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../auth";
import { useI18n, LANGS } from "../i18n";
import { LOGO, Button, Input, Label, Card } from "../components/ui";
import { ArrowLeft } from "lucide-react";

const DEMO = [
  ["Super admin", "super@spinatech.demo"],
  ["Admin cabinet", "admin@spinatech.demo"],
  ["Professionnel", "pro1@spinatech.demo"],
  ["Assistant(e)", "assist@spinatech.demo"],
  ["Patient", "patient1@spinatech.demo"],
];

export default function Login() {
  const { login } = useAuth();
  const { t, lang, setLang } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) { setError(res.error); return; }
    navigate(res.user.role === "patient" ? "/portail" : "/app");
  };

  const quick = (mail) => { setEmail(mail); setPassword("Demo1234!"); };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
        <div className="absolute -top-24 -end-24 h-96 w-96 rounded-full bg-teal/20 blur-3xl" />
        <Link to="/" className="flex items-center gap-3 relative">
          <img src={LOGO} className="h-11 w-11 object-contain bg-white rounded-lg p-1" alt="SpinaGo" />
          <div><div className="font-head font-extrabold text-2xl">SpinaGo</div><div className="text-xs text-teal-400">by SpinaTech</div></div>
        </Link>
        <div className="relative">
          <h2 className="font-head font-bold text-3xl leading-tight mb-3">{t("hero_title")}</h2>
          <p className="text-white/60 max-w-sm">{t("hero_sub")}</p>
        </div>
        <p className="text-xs text-white/40 relative">{t("footer_legal")}</p>
      </div>

      <div className="flex flex-col items-center justify-center p-6 bg-vlg">
        <div className="w-full max-w-md">
          <div className="flex items-center justify-between mb-6">
            <Link to="/" className="flex items-center gap-1 text-sm text-slate-500 hover:text-navy"><ArrowLeft size={16} /> Accueil</Link>
            <select value={lang} onChange={(e) => setLang(e.target.value)} className="text-sm border border-slate-200 rounded-lg px-2 py-1.5 bg-white">
              {LANGS.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
            </select>
          </div>
          <div className="lg:hidden flex items-center gap-2.5 mb-6">
            <img src={LOGO} className="h-10 w-10 object-contain" alt="" />
            <span className="font-head font-extrabold text-navy text-2xl">Spina<span className="text-teal">Go</span></span>
          </div>
          <h1 className="font-head font-bold text-navy text-2xl mb-1">{t("login")}</h1>
          <p className="text-sm text-slate-500 mb-6">SpinaGo by SpinaTech</p>

          <form onSubmit={submit} className="space-y-4">
            <div><Label>{t("email")}</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@cabinet.dz" /></div>
            <div><Label>{t("password")}</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></div>
            {error && <div data-testid="login-error" className="text-sm text-alert bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
            <Button type="submit" size="lg" className="w-full" disabled={busy} data-testid="login-submit">
              {busy ? t("loading") : t("login_btn")}
            </Button>
          </form>

          <Card className="mt-6 p-4">
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Comptes de démonstration — Demo1234!</div>
            <div className="grid grid-cols-1 gap-1">
              {DEMO.map(([role, mail]) => (
                <button key={mail} onClick={() => quick(mail)} data-testid={`demo-${mail}`}
                  className="flex justify-between items-center text-start px-3 py-2 rounded-lg hover:bg-vlg text-sm">
                  <span className="font-medium text-navy">{role}</span>
                  <span className="text-slate-400 text-xs">{mail}</span>
                </button>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
